import { render, staticRenderFns } from "./AutomatorBlockSingleInput.vue?vue&type=template&id=36c54dc2&scoped=true&"
import script from "./AutomatorBlockSingleInput.vue?vue&type=script&lang=js&"
export * from "./AutomatorBlockSingleInput.vue?vue&type=script&lang=js&"
import style0 from "./AutomatorBlockSingleInput.vue?vue&type=style&index=0&id=36c54dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c54dc2",
  null
  
)

export default component.exports